import { useQuery } from '@tanstack/react-query';
import { getTechDetail } from '../services/AnalyticReportsService';
export default function useTechDetail(filters, technicianId) {
    return useQuery(['techDetail', filters.values.dateRange, technicianId], () => getTechDetail(filters, technicianId), {
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000,
        enabled: technicianId !== null,
        keepPreviousData: true,
    });
}
